import React, { useContext, useState } from "react";
import "./case-actions.component.scoped.scss";
import { Box, Button } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import PrintIcon from "@material-ui/icons/Print";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import DeleteIcon from "@material-ui/icons/DeleteOutline";
import { CaseContext, GlobalContext } from "../../../../../store";
import { CasesService } from "../../../../../services/cases/cases.service";
import {
  extractIds,
  showPopupToastMsg,
  showToastMsg,
} from "../../../../../helpers";
import { history } from "react-router-guard";
import { ConfirmDialog } from "../../../../../dialogs/confirm-dialog/confirm-dialog";
import { Dropdown } from "react-bootstrap";
import { UserRoles } from "../../../../../types/userRoles";

const CaseActionsComponent = ({
  onResetChanges,
}: {
  onResetChanges: () => void;
}) => {
  const { t } = useTranslation();
  const casesServices = new CasesService();
  const { user } = useContext(GlobalContext);
  const {
    setCaseDetails,
    setCaseDetailsForm,
    caseDetails,
    caseDetailsForm,
  } = useContext(CaseContext);
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [showConfirmVersionModal, setShowConfirmVersionModal] = useState(false);
  const [releaseData, setReleaseData] = useState({
    major: 0,
    minor: 0,
    version: 0,
  });
  const [dialogTitle, setDialogTitle] = useState("");
  const [dialogBody, setDialogBody] = useState("");

  const [saving, setSaving] = useState(false);

  const updateCase = async () => {
    setSaving(true);
    const formattedDate = {
      version: ++caseDetailsForm.version,
      title: caseDetailsForm.title,
      brief: caseDetailsForm.brief,
      description: caseDetailsForm.description,
      link: caseDetailsForm.link,
      scenarioDescription: caseDetailsForm.scenarioDescription,

      areasIds:
        JSON.stringify(extractIds(caseDetails.areas).sort()) ===
        JSON.stringify(caseDetailsForm.areasIds.sort())
          ? []
          : caseDetailsForm.areasIds,

      operationsIds:
        JSON.stringify(extractIds(caseDetails.operations).sort()) ===
        JSON.stringify(caseDetailsForm.operationsIds.sort())
          ? []
          : caseDetailsForm.operationsIds,

      algorithmsIds:
        JSON.stringify(extractIds(caseDetails.algorithms).sort()) ===
        JSON.stringify(caseDetailsForm.algorithmsIds.sort())
          ? []
          : caseDetailsForm.algorithmsIds,

      techniquesIds:
        JSON.stringify(extractIds(caseDetails.techniques).sort()) ===
        JSON.stringify(caseDetailsForm.techniquesIds.sort())
          ? []
          : caseDetailsForm.techniquesIds,
      machineLearningIds:
        JSON.stringify(extractIds(caseDetails.machineLearning).sort()) ===
        JSON.stringify(caseDetailsForm.machineLearningIds.sort())
          ? []
          : caseDetailsForm.machineLearningIds,
    };

    const res = await casesServices.update(caseDetails.id, formattedDate);
    if (res.message === "SUCCESS") {
      setCaseDetails({ ...caseDetails, ...caseDetailsForm });
      showToastMsg("success", t("CASE_UPDATED_SUCCESSFULLY"));
    } else {
      showPopupToastMsg("error", t("SOME_THING_WENT_WRONG"));
    }
    setSaving(false);
  };

  const onUpdateVersion = async (type: "major" | "minor") => {
    const data = {
      version: caseDetails.version,
      minor: caseDetails.minor,
      major: caseDetails.major,
    };

    if (type === "major") {
      data.major = ++data.major;
      data.minor = 0;
      data.version = 0;
    } else {
      data.minor = ++data.minor;
      data.version = 0;
    }

    const version = `${data.major.toLocaleString("en-US", {
      minimumIntegerDigits: 2,
    })}.${data.minor.toLocaleString("en-US", {
      minimumIntegerDigits: 2,
    })}.${data.version.toLocaleString("en-US", {
      minimumIntegerDigits: 2,
    })}`;

    setReleaseData(data);
    setDialogTitle(`${t("PUBLISH_VERSION", { type })}`);
    setDialogBody(
      `${t("REALLY_YOU_WANT_PUBLISH_VERSION_TYPE", { type, version })}`,
    );
    setShowConfirmVersionModal(true);
  };

  const updateVersion = async (value: boolean) => {
    setShowConfirmVersionModal(false);
    if (value) {
      setSaving(true);
      const res = await casesServices.updateVersions(
        caseDetails.id,
        releaseData,
      );
      if (res.message === "Success") {
        setCaseDetails({ ...caseDetails, ...releaseData });
        setCaseDetailsForm({
          ...caseDetailsForm,
          version: releaseData.version,
        });
        showToastMsg("success", t("CASE_UPDATED_SUCCESSFULLY"));
      } else {
        showPopupToastMsg("error", t("SOME_THING_WENT_WRONG"));
      }
      setSaving(false);
    }
  };

  // const downloadPdf = async () => {
  //   const doc = new jsPDF("p");
  //   doc.setFontSize(15);
  //   let lineHeight = 10;

  //   lineHeight += 3;

  //   doc.text(
  //     `${t("category")}: ${caseDetails.category}`,
  //     10,
  //     (lineHeight += 10)
  //   );

  //   doc.text(`${t("country")}: ${caseDetails.land}`, 10, (lineHeight += 10));
  //   doc.text(
  //     `${t("amount")}: ${caseDetails.amount ? caseDetails.amount : ""}`,
  //     10,
  //     (lineHeight += 10)
  //   );
  //   doc.text(
  //     `${t("ongoing-case")}: ${caseDetails.caseOngoing ? t("yes") : t("No")}`,
  //     10,
  //     (lineHeight += 10)
  //   );

  //   doc.text(
  //     `${t("relation")}: ${
  //       caseDetails.relationship ? caseDetails.relationship : ""
  //     }`,
  //     10,
  //     (lineHeight += 10)
  //   );
  //   doc.text(
  //     `${t("start date")}: ${
  //       caseDetails.startDate ? caseDetails.startDate : ""
  //     }`,
  //     10,
  //     (lineHeight += 10)
  //   );
  //   doc.text(
  //     `${t("end date")}: ${caseDetails.endDate ? caseDetails.endDate : ""}`,
  //     10,
  //     (lineHeight += 10)
  //   );
  //   // set line-height for description
  //   doc.setLineHeightFactor(1.5);
  //   const description = doc.splitTextToSize(
  //     `${t("description")}: ${caseDetails.description.replace(/<[^>]+>/g, "")}`,
  //     180
  //   );
  //   // add new page with condition
  //   const pageHeight = doc.internal.pageSize.getHeight();
  //   description.forEach((text: any) => {
  //     if (lineHeight + 10 > pageHeight) {
  //       lineHeight = 10;
  //       doc.addPage();
  //     }
  //     doc.text(text, 10, (lineHeight += 10));
  //   });
  //   doc.setProperties({ title: `${t("case")}-${caseDetails.internalId}` });
  //   let blobPDF = doc.output("blob");
  //   const blob = new Blob([blobPDF], {
  //     type: "pdf/plain;charset=utf-8",
  //   });
  //   saveAs(blob, `${t("case")}.pdf`);
  // };

  const deleteCase = async (value: any) => {
    setShowConfirmDeleteModal(false);
    if (value) {
      const res = await casesServices.deleteCase(caseDetails.id);
      if (res.message === "Success") {
        showToastMsg("success", t("CASE_DELETED_SUCCESSFULLY"));
        if (caseDetails.rold === "DEVELOPER") {
          history.push("/ai-products");
        } else if (caseDetails.role === "USER") {
          history.push("/ai-demand");
        } else if (
          caseDetails.role === "DISTRIBUTER" ||
          caseDetails.role === "IMPORTER"
        ) {
          history.push("/ai-inventory");
        } else {
          history.push("/dashboard");
        }
      } else {
        showPopupToastMsg("error", t("SOME_THING_WENT_WRONG"));
      }
    }
  };

  const caseUpdated = () => {
    if (
      caseDetails.title === caseDetailsForm.title &&
      caseDetails.brief === caseDetailsForm.brief &&
      caseDetails.description === caseDetailsForm.description &&
      caseDetails.scenarioDescription === caseDetailsForm.scenarioDescription &&
      JSON.stringify(caseDetails.areasIds.sort()) ===
        JSON.stringify(caseDetailsForm.areasIds.sort()) &&
      JSON.stringify(caseDetails.operationsIds.sort()) ===
        JSON.stringify(caseDetailsForm.operationsIds.sort()) &&
      JSON.stringify(caseDetails.algorithmsIds.sort()) ===
        JSON.stringify(caseDetailsForm.algorithmsIds.sort()) &&
      JSON.stringify(caseDetails.techniquesIds.sort()) ===
        JSON.stringify(caseDetailsForm.techniquesIds.sort()) &&
      JSON.stringify(caseDetails.machineLearningIds.sort()) ===
        JSON.stringify(caseDetailsForm.machineLearningIds.sort())
    ) {
      return true;
    } else if (
      (caseDetails.role !== "USER" &&
        (!caseDetailsForm.techniquesIds.length ||
          !caseDetailsForm.machineLearningIds.length)) ||
      !caseDetailsForm.areasIds.length ||
      caseDetailsForm.scenarioDescription.length > 2500 ||
      caseDetailsForm.description.length > 2500
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Box className="content">
      <Box className="left-action">
        {(user.role === UserRoles.SUPER_ADMIN ||
          user.role === UserRoles.COORDINATOR) && (
          <Button
            className="btn-secondary-theme mb-0"
            variant="outlined"
            color="primary"
            size="medium"
            onClick={setShowConfirmDeleteModal.bind(null, true)}
          >
            <DeleteIcon style={{ cursor: "pointer" }} />
            <span className="ml-1">{t("DELETE")}</span>
          </Button>
        )}
      </Box>
      <Box className="right-action">
        <Button
          className="btn-secondary-theme mb-0"
          variant="outlined"
          color="primary"
          size="medium"
          onClick={() => window.print()}
        >
          <PrintIcon />
          <span className="ml-1">{t("PRINT")}</span>
        </Button>

        <Dropdown className="version-dropdown mb-0">
          <Dropdown.Toggle disabled={saving || caseUpdated()}>
            <span className="ml-1">{t("SUBMIT")}</span>
            <ExpandMoreIcon />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item
              disabled={saving || caseUpdated()}
              onClick={updateCase}
            >
              {t("SAVE")}
            </Dropdown.Item>
            <Dropdown.Item
              disabled={saving || caseUpdated()}
              onClick={onResetChanges}
            >
              {t("CANCEL")}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <Dropdown className="version-dropdown mb-0">
          <Dropdown.Toggle disabled={saving}>
            <span className="ml-1">{t("PUBLISH")}</span>
            <ExpandMoreIcon />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item
              disabled={saving}
              onClick={onUpdateVersion.bind(false, "major")}
            >
              {t("PUBLISH")} Major
            </Dropdown.Item>
            <Dropdown.Item
              disabled={saving}
              onClick={onUpdateVersion.bind(false, "minor")}
            >
              {t("PUBLISH")} Minor
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Box>

      {showConfirmDeleteModal && (
        <ConfirmDialog
          show={showConfirmDeleteModal}
          onClose={deleteCase}
          dialogTitle={t("CONFIRM_DELETE_CASE")}
          dialogBody={t("ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_CASE")}
          confirmBtnText={t("DELETE")}
          cancelBtn={true}
        />
      )}

      {showConfirmVersionModal && (
        <ConfirmDialog
          show={showConfirmVersionModal}
          onClose={updateVersion}
          dialogTitle={dialogTitle}
          dialogBody={dialogBody}
          confirmBtnText={t("PUBLISH")}
          cancelBtn={true}
        />
      )}
    </Box>
  );
};

export default CaseActionsComponent;
